import 'react';
import { jsx } from '@emotion/core';
import { ButtonGroup, Button } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { DrawMode } from "../types/index.js";
import useStores from "../hooks/useStores.js";
import PdfToolbar from "./PdfToolbar.js";

var DrawablePdfToolbar = function DrawablePdfToolbar() {
  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  return jsx(PdfToolbar, null, jsx("span", {
    className: "mr-2"
  }, "Draw"), jsx(ButtonGroup, null, jsx(Button, {
    "data-testid": "textfield",
    active: pdfStore.drawMode === DrawMode.TextField,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.TextField);
    }
  }, "Text Field"), jsx(Button, {
    "data-testid": "checkbox",
    active: pdfStore.drawMode === DrawMode.Checkbox,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Checkbox);
    }
  }, "Checkbox"), jsx(Button, {
    "data-testid": "signature",
    active: pdfStore.drawMode === DrawMode.Signature,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Signature);
    }
  }, "Signature"), jsx(Button, {
    "data-testid": "initials",
    active: pdfStore.drawMode === DrawMode.Initials,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Initials);
    }
  }, "Initials")));
};

DrawablePdfToolbar.displayName = "DrawablePdfToolbar";
var DrawablePdfToolbar$1 = observer(DrawablePdfToolbar);
export default DrawablePdfToolbar$1;